import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import ElementTypeEditService from '../service/ElementTypeEditService';

const config = {
	key: 'elementTypeEditForm',
	text: 'Element Type',
	textKey: 'elementType',
	service: ElementTypeEditService,
	fields: [
		{
			key: 'name',
			text: 'Name',
			textKey: 'name',
			component: EditFormTextField,
			required: true
		}
	]
};

function ElementTypeEditForm() {
	return <EditFormPage config={config} />;
}

export default ElementTypeEditForm;
